"use client";

import { useLocale } from "next-intl";
import { useState } from "react";

const WHATSAPP_URL = "https://wa.me/201220922228";

export default function WhatsAppCTA() {
  const locale = useLocale();
  const isAr = locale === "ar";
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={isAr ? "تواصل معنا عبر واتساب" : "Chat with us on WhatsApp"}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="fixed bottom-6 end-6 z-999 flex items-center gap-3 group"
    >
      {/* Tooltip */}
      <span
        className={`
          text-sm font-semibold text-white bg-[#25D366] px-3 py-1.5 rounded-full shadow-lg
          transition-all duration-300 whitespace-nowrap select-none pointer-events-none
          ${hovered ? "opacity-100 translate-x-0" : "opacity-0 translate-x-2"}
          ${isAr ? "order-2" : "order-1"}
        `}
      >
        {isAr ? "تواصل معنا" : "Chat with us"}
      </span>

      {/* Button */}
      <span className={`relative ${isAr ? "order-1" : "order-2"}`}>
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
        <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-xl shadow-[#25D366]/40 hover:scale-110 active:scale-95 transition-transform duration-200">
          {/* WhatsApp SVG icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            className="w-7 h-7 fill-white"
          >
            <path d="M16 0C7.163 0 0 7.163 0 16c0 2.824.738 5.476 2.027 7.782L0 32l8.43-2.007A15.938 15.938 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.282 13.282 0 0 1-6.781-1.857l-.487-.29-5.003 1.191 1.221-4.867-.317-.5A13.268 13.268 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.865c-.398-.2-2.355-1.162-2.72-1.294-.366-.133-.632-.2-.898.2-.265.397-1.031 1.294-1.264 1.562-.233.265-.465.298-.864.1-.398-.2-1.682-.62-3.204-1.978-1.184-1.057-1.983-2.363-2.215-2.761-.233-.398-.025-.613.175-.812.18-.178.398-.466.597-.698.2-.232.265-.398.398-.664.133-.265.066-.498-.033-.698-.1-.2-.898-2.162-1.23-2.96-.323-.775-.65-.67-.898-.682l-.765-.013c-.265 0-.698.1-1.064.498-.366.398-1.396 1.362-1.396 3.323s1.43 3.855 1.63 4.122c.2.265 2.816 4.296 6.82 6.026.953.412 1.697.658 2.277.843.957.305 1.829.262 2.517.159.768-.115 2.355-.963 2.688-1.893.333-.93.333-1.727.233-1.893-.1-.165-.365-.265-.764-.464z" />
          </svg>
        </span>
      </span>
    </a>
  );
}
